import React from "react";
import { cn } from "@/lib/utils";
import { useLanguage } from "../hooks/use-language/use-language";

export const LanguageToggle: React.FC = ({
  className,
  btnClass,
  textcls,
}) => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className={` flex h- ${className} `}>
      <div
        className={`relative flex rounded-full bg-white/20  ${btnClass} p-1 backdrop-blur`}
      >
        {/* Sliding active background */}
        <div
          className={cn(
            `absolute inset-y-1  w-1/2 rounded-full bg-gray-900 transition-transform duration-300 `,
            language === "hi" && `translate-x-full -inset-x-1 `,
          )}
        />

        {/* English Tab */}
        <button
          onClick={() => setLanguage("en")}
          className={cn(
            "h-[2rem] text-left relative z-10 px-6 py-2 rounded-full text-sm font-medium transition-colors flex items-center",
            language === "en"
              ? `text-white  `
              : `${textcls} hover:text-black-100 `,
          )}
        >
          English
        </button>

        {/* Hindi Tab */}
        <button
          onClick={() => setLanguage("hi")}
          className={cn(
            "h-[2rem] text-right relative z-10 px-6 py-2 rounded-full text-sm font-medium transition-colors flex items-center",
            language === "hi"
              ? `text-white `
              : `${textcls} hover:text-black-100`,
          )}
        >
          हिंदी
        </button>
      </div>
    </div>
  );
};
